module.exports = __webpack_public_path__ + "/login_ui/img/tt-a27db96aed9a0377f3fd1d6c6cb53aa8.svg";